module.exports = {
  Undo: require('./undo_tool'),
  Redo: require('./redo_tool'),
  Emphasis: require('./emphasis_tool'),
  Strong: require('./strong_tool'),
  Link: require('./link_tool'),
  SwitchTextType: require('./switch_text_type_tool'),
  InsertRows: require('./insert_rows'),
  DeleteRows: require('./delete_rows'),
  InsertColumns: require('./insert_columns'),
  DeleteColumns: require('./delete_columns'),
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/surface/tools/index.js
 ** module id = 240
 ** module chunks = 0
 **/